import type { OrderSearchResult } from '@/api/models';

export const findNewOrders = (orders: OrderSearchResult[], knownIds: ReadonlySet<number>): OrderSearchResult[] => {
  const ids = new Set(knownIds);
  return orders.filter((order) => {
    if (ids.has(order.orderMstrId)) return false;
    ids.add(order.orderMstrId);
    return true;
  });
};

export const prependOrders = (additions: OrderSearchResult[], orders: OrderSearchResult[]): OrderSearchResult[] => {
  return findNewOrders([...additions, ...orders], new Set());
};
